const Example = () => {
  console.log("example");
  return <div>ok google</div>;
};

export default Example;
